import { store, getElement } from "@wordpress/interactivity";
 
const { state } = store( 'frs-blocks/table', {
  state: { },
  actions: {},
  callbacks: {
    initialize: () => {
        const element = getElement();
        const row = element.ref.querySelector('.wp-block-frs-blocks-table--head');
        if(row)
        {
          const cols = row.querySelectorAll('.wp-block-frs-blocks-text');
          if(cols && cols.length > 2)
          {
            element.ref.style.setProperty('--first-column-label', `"${cols[1].innerText.replaceAll("\\", "\\\\")}: "`);
            element.ref.style.setProperty('--second-column-label', `"${cols[2].innerText.replaceAll("\\", "\\\\")}: "`);
          }
        }
    },
  },
});


